import React, { FunctionComponent } from 'react'
import styles from './DesignStatusElement.module.sass'
import DesignIcon from '../../../../../files/design-status/design.svg'
import ProductionIcon from '../../../../../files/design-status/production.svg'
import clsx from 'clsx'
import Tooltip from '../../../etc/Tooltip'
import { DesignStatus, designStatusToClass, designStatusToText } from '../../../../responses/objects'

interface Props {
    className?: string,
    status: DesignStatus,
    type: 'design' | 'production',
    tooltip?: boolean,
    small?: boolean,
    allowEmpty?: boolean,
}

const DesignStatusElement: FunctionComponent<Props> = props => <Tooltip
    className={clsx(props.className, styles.element, styles[designStatusToClass(props.status)], {[styles.small]: props.small})}
    title={{
        disable: !props.tooltip,
        content: designStatusToText(props.status, props.type === 'design')
    }}>
    {
        (props.allowEmpty || props.status !== DesignStatus.NONE) && <>
        {
            props.type === 'design' ?
                <DesignIcon/> :
                <ProductionIcon/>
        }
        </>
    }
</Tooltip>

export default DesignStatusElement